import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=4d147ac2&"
import script from "./MonitorList.vue?vue&type=script&lang=ts&"
export * from "./MonitorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports